import clone from 'lodash/clone';
import filter from 'lodash/filter';
import find from 'lodash/find';
import pull from 'lodash/pull';
import adSlotFactory from './adSlotFactory';
const mySlots = [];
let companionSlots = [];
export default {
    addSlot(slotName, elementId, dimensions) {
        let slot = find(mySlots, ['name', slotName]);
        if (!slot) {
            slot = adSlotFactory.createAdSlot(slotName, elementId, dimensions);
            if (slot) {
                mySlots.push(slot);
            }
        }
        return slot;
    },
    removeSlot(elementIdOrSlotName) {
        const slot = find(mySlots, ['elementId', elementIdOrSlotName]) ||
            find(mySlots, ['name', elementIdOrSlotName]);
        if (slot) {
            pull(mySlots, slot);
        }
        return slot;
    },
    getSlot(elementIdOrSlotName) {
        return (this.getSlotWhere(['elementId', elementIdOrSlotName]) ||
            this.getSlotWhere(['name', elementIdOrSlotName]));
    },
    getDisplaySlots() {
        return this.getSlotsWhere((_slot) => {
            return _slot.medium === 'display';
        });
    },
    getSlotWhere(predicate) {
        return find(mySlots, predicate);
    },
    getSlotsWhere(predicate) {
        return filter(mySlots, predicate);
    },
    getSlots() {
        return clone(mySlots);
    },
    addCompanionSlot(slot) {
        companionSlots.push(slot);
    },
    getCompanionSlots() {
        return clone(companionSlots);
    },
    resetCompanionSlots() {
        companionSlots = [];
    },
};
